import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "customers-from-channels-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "p-0 m-0 list-unstyled" }
const _hoisted_5 = { class: "title d-flex align-items-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "d-block fw-semibold text-black" }
const _hoisted_8 = { class: "d-block" }
const _hoisted_9 = { class: "percentage-progress d-flex align-items-center" }
const _hoisted_10 = ["aria-valuenow"]
const _hoisted_11 = { class: "d-block percentage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Customers From Channels")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (channel) => {
            return (_openBlock(), _createElementBlock("li", {
              key: channel.name,
              class: "d-flex align-items-center justify-content-between"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: channel.icon,
                  alt: channel.name
                }, null, 8, _hoisted_6),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(channel.name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(channel.description), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "progress trezo-progress w-100",
                  role: "progressbar",
                  "aria-valuenow": channel.percentage,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["progress-bar", channel.progressBarClass]),
                    style: _normalizeStyle({ width: channel.percentage + '%' })
                  }, null, 6)
                ], 8, _hoisted_10),
                _createElementVNode("span", _hoisted_11, _toDisplayString(channel.percentage) + "%", 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}